module.exports = __webpack_public_path__ + "static/nz_digital_wallet-samsung-pay-phone-7c136499b7f015e0300cde75504fed7b.png";